<template>
  <section
    v-if="variants.v1 === variant && blog"
    class="layout-pt-lg layout-pb-lg"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="container tw-mt-8 tw-grid tw-grid-cols-12 tw-gap-y-16 lg:tw-gap-x-12">
      <article
        class="tw-col-span-12 tw-h-fit lg:tw-col-span-7 xl:tw-col-span-8"
        style="border-radius: var(--rounded); background-color: var(--c-section_primary)"
      >
      <h2 class="tw-uppercase">{{ blog.title }}</h2>

        <div class="tw-mb-10 tw-w-full">
          <NuxtImg
            v-if="blog.media_type === 'image'"
            :src="blog.largeImage"
            loading="lazy"
            :alt="blog.title"
            class="tw-w-full"
            :title="blog.title"
            style="border-radius: var(--rounded)"
            sizes="(max-width: 479px) 92vw, (max-width: 767px) 93vw, (max-width: 1439px) 92vw, 1280px"
            :srcset="`${blog.largeImage} 500w,
                ${blog.largeImage} 800w,
                ${blog.largeImage} 1080w,
               ${blog.largeImage} 1600w,
                ${blog.largeImage} 2500w`"
          />
          <library-iframe v-else-if="blog.media_type === 'video'" :src="blog.video_link"> </library-iframe>
        </div>

        <div
          v-if="blog.description"
          style="
            padding: 0 20px;
            color: var(--c-text-primary);
            background-color: var(--c-input);
            border-radius: var(--rounded);
            border-left: 3px solid var(--c-secondary);
          "
          class="tw-my-10"
        >
          <small>{{ blog.description }}</small>
        </div>
        <div style="font-family: var(--f-primary) !important">
  <lazy-library-text :html="blog.content" />
</div>
      </article>

      <div class="tw-col-span-12 lg:tw-col-span-5 xl:tw-col-span-4">
        <div v-if="form" class="tw-mb-6 tw-px-6 tw-py-8" style="border-radius: var(--rounded); background: transparent">
          <library-form :form="form" version="v2" :component="component"></library-form>
        </div>
        <template v-if="sidebarComponents && sidebarComponents.length">
          <div class="sidebar tw-flex tw-flex-col tw-gap-6">
            <available-components-for-sidebar
              key="blog-detail-sidebar"
              key-prefix="blog-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { BlogMixin } from '~/units/blogs/mixins/blog.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { ROUTES } from '~/constants/ui.constants';
import AvailableComponentsForSidebar from '~/components/theme9/AvailableComponentsForSidebar.vue';
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';

export default defineNuxtComponent({
  name: 'Theme9BlogDetail',

  mixins: [ComponentMixin, BlogMixin],

  components: { AvailableComponentsForSidebar },

  data() {
    return { form: null, variants: { v1: 'v1' } };
  },

  created() {
    this.form = this.parseFormV2(this.vars.blogForm);
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchSingleBlog(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),

    ROUTES() {
      return ROUTES;
    },
  },
});
</script>

<style scoped>
.blog-detail-content ::v-deep(*) {
  color: var(--c-text-primary) !important;
}

.blog-detail-content ::v-deep(a) {
  padding: 0 !important;
}

.blog-detail-content ::v-deep(iframe) {
  max-width: 100%;
}
</style>
